import { render, staticRenderFns } from "./basicDataTotal.vue?vue&type=template&id=4bcb494b&scoped=true"
import script from "./basicDataTotal.vue?vue&type=script&lang=js"
export * from "./basicDataTotal.vue?vue&type=script&lang=js"
import style0 from "./basicDataTotal.vue?vue&type=style&index=0&id=4bcb494b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb494b",
  null
  
)

export default component.exports